import * as React from 'react'
import { Home } from 'react-feather'

import { useWhitelabel } from 'main/framework'
import { Strong, Text } from 'main/ui'

import { useTranslation } from 'react-i18next'
import { LOCIZE_NAMESPACE } from '../../../common'
import Bullet from '../common/Bullet'
import { i18nKeyPrefix } from '../i18n'

const PRE = `${i18nKeyPrefix}-PROGRAM-TYPE`

interface IProps {
  programType: string | null
}

export default function ProgramType(props: IProps) {
  const { programType } = props
  const { t } = useTranslation(LOCIZE_NAMESPACE)
  const whitelabel = useWhitelabel()

  function labelForProgramTypeValue(value: string | null) {
    if (!programType) return ''

    switch (value) {
      case 'fcc':
        return t(`${PRE}-FCC`)
      case 'center':
        return t(`${PRE}-CENTER`)
      case 'forest':
        return t(`${PRE}-FOREST`)
      case 'micro':
        return t(`${PRE}-MICRO`)
      case 'ministry':
        return t(`${PRE}-MINISTRY`)
      case 'exempt':
        return t(`${PRE}-EXEMPT`)
      case 'nanny':
        return t(`${PRE}-NANNY`)
    }
  }

  function labelForProgramTypeHeader(networkAbbr: string | undefined) {
    switch (networkAbbr) {
      case 'NM':
        return t(`${PRE}-TEXT-NM`)
      default:
        return t(`${PRE}-TEXT`)
    }
  }

  return (
    <Bullet icon={<Home />}>
      <Strong>{labelForProgramTypeHeader(whitelabel.networkAbbr)}</Strong>
      <Text muted>{labelForProgramTypeValue(programType)}</Text>
    </Bullet>
  )
}
